import LocalStorageService from '../services/LocalStorageService';
import OrganisationService from '../services/OrganisationService';

const getPermissionContext = () => {
  return {
    userDetails: LocalStorageService.get('userDetails'),
    activeOrg: LocalStorageService.get('activeOrg'),
    activeSite: LocalStorageService.get('activeSite'),
    apiToken: LocalStorageService.get('apiToken')
  };
};


const isCpomsEnabled = () => {
  const activeOrg = LocalStorageService.get('activeOrg');
  return activeOrg?.cpomsEnabled || false;
}

const isServiceAdmin = () => {

  let userDetails = LocalStorageService.get('userDetails');
  let activeOrg = LocalStorageService.get('activeOrg');

  if (!activeOrg) { return false; }
  if (!userDetails?.id) { return false; } 

  // make a lowercase comparison
  const email = userDetails.email?.toLocaleLowerCase();

  return activeOrg.isSafeguardingLead || false;
}

const currentOrgHasSitesEnabled = () => {
  const { activeOrg } = getPermissionContext();

  // if there's no activeOrg something is wrong, return false
  if (!activeOrg) {
    return false;
  }
  // get the active org, does it have sites?
  return activeOrg.hasSites || false;
};

const hasAnyPermissionIn = permissions => {
  if (!permissions?.length) {
    return false;
  }

  for (const permission of permissions) {
    if (hasPermission(permission)) {
      return true;
    }
  }

  // otherwise, return no
  return false;
};

const hasPermission = permission => {
  const { activeOrg, activeSite } = getPermissionContext();

  // if there's no activeOrg something is wrong, return false
  if (!activeOrg) {
    return false;
  }

  // get the active org, does it have sites?
  const hasSites = currentOrgHasSitesEnabled();

  // if the org has sites, use the permission for the site
  if (hasSites) {
    // no active site or no permissions no access
    if (!activeSite || !activeSite.permissions) {
      return false;
    }
    return activeSite.permissions.includes(permission);
    // otherwise, use the permission for the org
  } else {
    // no permissions on the active org, no check
    if (!activeOrg.permissions) {
      return false;
    }

    return activeOrg.permissions.includes(permission);
  }
};

const isGlobalAdmin = () => {
  const { userDetails } = getPermissionContext();
  return userDetails?.isGlobalAdmin;
};

const isAdmin = () => {
  const { activeOrg } = getPermissionContext();
  return activeOrg?.isAdmin || false;
}

const isAnyAdmin = async () => {
  const { activeOrg, userDetails, apiToken } = getPermissionContext();

  // not logged in, or no real user
  if (!activeOrg || !userDetails?.id) {
    return false;
  }

  // check if the user is the org admin
  if (activeOrg.orgAdmin === userDetails.id) {
    return true;
  }

  // check if the user is an other admin for the org
  const otherAdmins = await OrganisationService.getOtherAdmins(apiToken, activeOrg.id);
  return otherAdmins?.data?.some(admin => admin.id === userDetails.id) || false;
}

const isCurrentOrgAdmin = () => {
  const { activeOrg, userDetails } = getPermissionContext();

  if (!activeOrg || !activeOrg.orgAdmin) {
    // if there's no activeOrg something is wrong, return false
    return false;
  }

  // Return true for gloabal admin
  if (isGlobalAdmin()) return true;

  // is the org admin me?
  return activeOrg.orgAdmin === userDetails.id;
};

export {
  currentOrgHasSitesEnabled,
  hasPermission,
  hasAnyPermissionIn,
  isGlobalAdmin,
  isCurrentOrgAdmin,
  isAdmin,
  isServiceAdmin,
  isAnyAdmin,
  isCpomsEnabled
};
